
/**
 * JavaScript React Framework
 */
import React from 'react';

/**
 * React-Bootstrap
 */ 
import { NavDropdown, MenuItem } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import NavBarMenuItem from '../../common/navbar/NavBarMenuItem.js';
import pdf_01 from '../../../assets/pdf/manuscript/BrownTS_2016_Manuscript_TSQL_STUFF_HowTo.pdf';
import pdf_02 from '../../../assets/pdf/manuscript/BrownTS_2016_Academic_Manuscript.pdf';
import pdf_03 from '../../../assets/pdf/manuscript/BrownTS_2017_BrownsGeneralizedVitalsEquation.pdf';
// import pdf_04 from '../../../assets/pdf/manuscript/BrownTS_2017_Australian_Soil.pdf';
// import pdf_05 from '../../../assets/pdf/manuscript/BrownTS_2017_HalcyonTribute.pdf';

/**
 * Note: Your components tell React what you want to render
 */
class AppNavBar_WritingSamples extends React.Component {
	render() {
		return (
      <NavDropdown eventKey={this.props.eventKey} title="Writing Samples" id="nav-dropdown">
        <NavBarMenuItem eventKey={this.props.eventKey + ".1"} glyph="flash" href="http://shop.oreilly.com/product/9780596528393.do"> O'Reilly: Dynamic Apache with Ajax and JSON</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".2"} glyph="flash" href={pdf_01}> How-To Article: Row Set Aggregation into a Single Row using T-SQL</NavBarMenuItem>
        <MenuItem divider />
        <NavBarMenuItem eventKey={this.props.eventKey + ".3"} glyph="flash" href={pdf_02}> Manuscript, Academic Writing Sample</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".4"} glyph="flash" href={pdf_03}> Manuscript, Space Operations – Brown’s Generalized Vitals Equation</NavBarMenuItem>
        {
            /*
            <MenuItem divider />
            <NavBarMenuItem eventKey={this.props.eventKey + ".5"} glyph="flash" href={pdf_04}> Manuscript, Creative Non-Fiction: "Australian Soil"</NavBarMenuItem>
            <NavBarMenuItem eventKey={this.props.eventKey + ".6"} glyph="flash" href={pdf_05}> Manuscript, Short Creative Non-Fiction: "A Tribute to Halcyon"</NavBarMenuItem>
            */
        }
      </NavDropdown>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default AppNavBar_WritingSamples;



// WEBPACK FOOTER //
// ./src/cba/appspec/header/Nav_AppNavBar_WritingSamples.js